import { Modal } from 'antd';
import { TermsContent } from './TermsContent';
import { PrivacyContent } from './PrivacyContent';

interface LegalModalProps {
  open: boolean;
  onClose: () => void;
}

export function TermsModal({ open, onClose }: LegalModalProps) {
  return (
    <Modal
      title="Terms of Service"
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      <p style={{ color: 'var(--color-text-muted)', marginBottom: 16 }}>Last updated: April 2026</p>
      <TermsContent />
    </Modal>
  );
}

export function PrivacyModal({ open, onClose }: LegalModalProps) {
  return (
    <Modal
      title="Privacy Policy"
      open={open}
      onCancel={onClose}
      footer={null}
      width={720}
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      <p style={{ color: 'var(--color-text-muted)', marginBottom: 16 }}>Last updated: April 2026</p>
      <PrivacyContent />
    </Modal>
  );
}
